import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EnvoiComponent } from './envoi.component';
import { BlockUIModule, ButtonModule, InputTextModule, PanelModule, TableModule } from 'primeng';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import {ProgressSpinnerModule} from 'primeng/progressspinner';


@NgModule({
  declarations: [EnvoiComponent],
  imports: [
    CommonModule,
    BrowserModule,
    PanelModule,
    FormsModule,
    InputTextModule,
    TableModule,
    ButtonModule,
    BlockUIModule,
    ProgressSpinnerModule
  ]
})
export class EnvoiModule { }
